module.exports = __webpack_public_path__ + "87fa7a803c5b3a5011d2a2f98c012112.svg";